/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
import {
  SIMS_LOADED,
  LOAD_SIM_REQ,
  LOAD_SIM_FINISH,
  LOAD_SIM_ERROR,
} from "../config/actionType";

const initialState = {
  loading: false,
  simCard: [],
  error: "",
};

export const simCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIMS_LOADED:
      return {
        ...state,
        simCards: action.simCards,
      };
    case LOAD_SIM_REQ:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case LOAD_SIM_ERROR:
      return {
        ...state,
        error: "Erreur requete",
      };
    case LOAD_SIM_FINISH:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
